import React from 'react';

const Artist = (
	{
		cssMod,
		img,
		channel,
		artist,
		day,
		changeButton,
		handleOnChange,
		inputImageFile,
		isEventLoading,
		handleOnClick,
		editBtn
	}) => {
	return (
		<div
			className={`artist ${cssMod || ''}`}
			onClick={handleOnClick}
		>
			<div className="artist_in">
				<div className="artist_img_w">
					{inputImageFile || img ? (
						<img className="artist_img" src={inputImageFile || img} alt={artist} />
					) : null}
				</div>
				<span className="artist_info">{channel}</span>
				<h3 className="artist_name">{artist}</h3>
				<span className="artist_info accent_mod">{day}</span>
				{editBtn ? (
					<span
						className="btn_edit artist_mod"
					>EDIT</span>
				) : null}
				{changeButton ? (
					<div className="artist_btn">
						<button
							className="btn_v3"
							disabled={isEventLoading}
						>Change Image
						</button>
						<input
							name="userFile"
							type="file"
							required
							className="artist_btn_input"
							onChange={handleOnChange}
						/>
					</div>
				) : false}
			</div>
		</div>
	);
}
export default Artist;